import http from '@/api/http'

function mapStaffProfile(payload = {}) {
  const title = String(payload.title ?? payload.restaurantTitle ?? '').trim()
  const id = payload.id != null && payload.id !== '' ? String(payload.id) : null
  const isActive = payload.is_active !== false
  const supportTelegramUrl =
    typeof payload.support_telegram_url === 'string' ? payload.support_telegram_url.trim() : ''

  return {
    id,
    restaurantTitle: title,
    isActive,
    status: isActive ? 'open' : 'closed',
    supportTelegramUrl,
  }
}

export async function fetchRestaurantStaffApi() {
  const { data } = await http.get('/restaurant/profile')
  const payload = data?.data ?? data ?? {}
  return mapStaffProfile(payload)
}

export async function updateRestaurantProfileActiveApi(isActive) {
  const { data } = await http.patch('/restaurant/profile', {
    is_active: Boolean(isActive),
  })
  const payload = data?.data ?? data ?? {}
  return mapStaffProfile(payload)
}
